/**
 * @file rec卡片组件
 * @author yanyiting@baidu.com
 * */

import {Component} from 'san';
import './index.scss';
import {GEM_APPRAISAL_RESULT} from '@const/index';

export default class RecItem extends Component {
    static template = `
        <div class="rec-item-wrap" on-click="itemClick(index)">
            <div class="img-wrap">
                <div class="cover"
                     style="background: url({{item.cover.url}}) center / cover no-repeat;
                            padding-top: {{item.cover.width / item.cover.height <= 0.8125 ? '133%' : '100%'}};">
                </div>
                <div class="type-icon type-icon{{item.gemType}}"></div>
                <div 
                    class="appraisal-icon"
                    s-if="{{item.gemType === 5 || item.gemType === 6}}"
                >{{gemAppraisal[item.appraisal_result.result-1].text}}</div>
                <div s-if="reflow" class="label">APP打开</div>
            </div>
            <div class="rec-item-info">
                <div class="info-title">{{item.title}}</div>
                <div class="bottom-bar">
                    <div class="avatar"
                         style="background: url({{item.author.avatar}}) center / 100% 100% no-repeat;">
                        <div class="circle-bg"></div>
                    </div>
                    <div class="nickname">{{item.author.nickname}}</div>
                    <div class="zan" s-if="reflow" on-click="likeClick($event)">
                        <span></span>
                        <span s-if="item.likeNum">{{item.likeNum}}</span>
                    </div>
                </div>
            </div>
        </div>
    `;

    initData() {
        return {
            gemAppraisal: GEM_APPRAISAL_RESULT
        };
    }

    itemClick() {
        let item = this.data.get('item');
        this.fire('itemclick', item);
    }

    likeClick(e) {
        e.stopPropagation();
        let item = this.data.get('item');
        this.fire('likeclick', item);
    }
}
